export default __webpack_public_path__ + "static/media/arrow-right.903f7d09.svg";